<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditEventoEdicaoDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <EventoEdicaoDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:remove="remover"
                         :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import EventoEdicaoDataTable from "../../components/shared/datatables/EventoEdicaoDataTable";
import BaseView from "../BaseView";
import {findOne,remove} from "../../api/eventoEdicao";
import CreateEditEventoEdicaoDialog from "../../components/shared/dialogs/CreateEditEventoEdicaoDialog";
import {findAll as findAllEvento} from '../../api/evento';
import {findAll as findAllEventoTipo} from '../../api/eventoTipo';
import {ItemDeDominio} from "../../api/itemsDominio";
import {mapActions, mapGetters} from "vuex";
import * as moment from 'moment';

export default {
  name: "index",
  components: {CreateEditEventoEdicaoDialog, BaseView, EventoEdicaoDataTable},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'Descricao',
          column: 'descricao',
          type: 'text'
        },
        {
          name: 'EventoTipo',
          column: 'idEventoTipo',
          type: 'autocomplete',
          optionsFactory: (search) => findAllEventoTipo(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
        {
          name: 'Evento',
          column: 'idEvento',
          type: 'autocomplete',
          optionsFactory: (search) => findAllEvento(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
        {
          group: 'Data Cronograma',
          columns: [
            {
              name: 'De',
              column: 'dtCronInicio',
              type: 'date',
            },
            {
              name: 'Até',
              column: 'dtCronFim',
              type: 'date',
            },
          ]
        },     
        {
          name: 'Inscrição',
          column: 'tipoAcessoEvento',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.TIPO_ACESSO_EVENTO
          })
        },    
        {
          name: 'Status',
          column: 'status',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.STATUS_PADRAO
          })
        },        
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {
        idEvento: null,
        idEventoTipo: null,
        dtInicioInscricao: "",
        dtFimInscricao: "",
        cep: "",	        
        estado: "",
        cidade: "",
        endereco: "",
        bairro: "",
        complemento: "",
        publicoAlvo: "TOD",
        numMaxInscricoes: 1,
        estadosPermitidos: [],
        portesPermitidos: [],
        atividadesEconomicasPermitidas: [],
        tipoAcessoEvento: null,
        status: "A",
        cronograma: [],
      };
      this.editDialogOpened = true;
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const retorno = await findOne(objeto.id);
        this.item = retorno.dados[0];
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados da Edição do Evento. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Edição do Evento removida com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        this.$toast.error(`Não foi possível remover a Edição do Evento.`, {
          timeout: 6000
        })
      } finally {
        this.loading = false;
      }
    },
	  async getPermissoes(){
      this.getPermissaoPorItemPerfil("EventoEdicao.cadastro",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>